"use client"

import NotFoundPage from "pages/404/NotFoundPage"

export default function NotFound() {
  return <NotFoundPage />
}
